import React from 'react';
import { Service } from '../../../../../dtos/version.dto';
import './service-info.scss';

type ServiceInfoProps = {
    service: Service
}

export const ServiceInfo: React.FC<ServiceInfoProps> = ({service}) => {
    return <div className="tooltip-content tooltip-service-content">
        <div className="item">
            <div className="label service-name">{service.displayName}</div>
            <div className="value service-description">
                {service.description?.split(String.raw`\n`)
                    .map((description) =>
                        <div key={description} className="description">{description}</div>
                    )}
            </div>
        </div>
        <div className="item">
            <div className="label">Protocol</div>
            <div className="value">{service.proto}</div>
        </div>
        <div className="item">
            <div className="label">Source Ports</div>
            <div className="value">{service.sports}</div>
        </div>
        <div className="item">
            <div className="label">Destination Ports</div>
            <div className="value">{service.dports}</div>
        </div>
    </div>;
};